import * as jose from 'jose';

import { useAuth0 } from '@auth0/auth0-react';

import useGlobalStore from 'hooks/useGlobalStore';

const useAccessToken = () => {
    const { getValue, setValue } = useGlobalStore({
        namespace: 'useAccessToken'
    });

    const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

    const accessToken = getValue('accessToken');
    const decodedToken = getValue('decodedToken');

    const fetchToken = async (orgId?: string, allowCache = true) => {
        try {
            if (isLoading || !isAuthenticated) {
                throw new Error('System not ready for this hook. User information unavailable.');
            }

            const accessToken = getValue('accessToken');

            const updatedAccessToken = await getAccessTokenSilently({
                authorizationParams: {
                    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
                    organization: orgId
                },
                cacheMode: allowCache ? 'on' : 'off'
            });

            if (!accessToken || accessToken !== updatedAccessToken) {
                setValue({ accessToken: updatedAccessToken });
                setValue({ decodedToken: jose.decodeJwt(updatedAccessToken) });
            }

            return updatedAccessToken;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            console.error(error.message);
        }
    };

    return {
        accessToken,
        decodedToken,
        fetchToken
    };
};

export default useAccessToken;
